import gql from "graphql-tag";
import { RequestListFragment } from "./fragments";

// export const GetClientRequests = gql`
//   query allRequests($params: JobsByClientFetchParams!, $queries: RequestsFetchQueries) {
//     allRequests(params: $params, queries: $queries) {
//       code
//       error
//       message
//       data {
//         ...RequestListFragment
//       }
//       countTotal
//     }
//   }
//   ${RequestListFragment}
// `;

export const GetClientRequests = gql`
  query allRequestsByClient($queries: RequestsByClientFetchQueries!) {
    allRequestsByClient(queries: $queries) {
      code
      error
      message
      data {
        ...RequestListFragment
      }
      countTotal
      totalPages
      currentPage
    }
  }
  ${RequestListFragment}
`;

export const GET_DETAILS_ADDR = gql`
  query detailsAddress($queries: DetailsAddressQueries!) {
    results: detailsAddress(queries: $queries) {
      code
      error
      message
      data {
        region
      }
    }
  }
`;

export const GET_REQUEST_BY_CLIENT = gql`
  query requestById($params: OneRequestFetchParams!) {
    results: requestById(params: $params) {
      code
      error
      message
      data {
        ...RequestListFragment
      }
    }
  }
  ${RequestListFragment}
`;
